// Datos estructurados para SEO
export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "TravelAgency",
  "name": "Belu Tours",
  "description": "Agencia de viajes especializada en destinos nacionales e internacionales con asesoramiento personalizado",
  "url": "https://belutoursviajesyturismo.tur.ar",
  "logo": "https://belutoursviajesyturismo.tur.ar/assets/logo-belutours-header.webp",
  "image": "https://belutoursviajesyturismo.tur.ar/assets/social-share.png",
  "telephone": "+54 261 123-4567",
  "email": "info@belutours.com",
  "address": {
    "@type": "PostalAddress",
    "addressCountry": "AR",
    "addressRegion": "Mendoza",
    "addressLocality": "Mendoza"
  },
  "sameAs": [
    "https://www.facebook.com/belutours",
    "https://www.instagram.com/belutours",
    "https://wa.me/542611234567"
  ],
  "serviceArea": {
    "@type": "Country",
    "name": "Argentina"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Paquetes de Viaje",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Viajes Nacionales",
          "description": "Paquetes turísticos por Argentina"
        }
      },
      {
        "@type": "Offer", 
        "itemOffered": {
          "@type": "Service",
          "name": "Viajes Internacionales",
          "description": "Paquetes turísticos internacionales"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service", 
          "name": "Cruceros",
          "description": "Cruceros por diferentes destinos"
        }
      }
    ]
  }
};

export const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "Belu Tours",
  "url": "https://belutoursviajesyturismo.tur.ar",
  "description": "Agencia de viajes con destinos nacionales e internacionales",
  "publisher": {
    "@type": "Organization",
    "name": "Belu Tours"
  },
  "potentialAction": {
    "@type": "SearchAction",
    "target": "https://belutoursviajesyturismo.tur.ar/destinos?busqueda={search_term_string}",
    "query-input": "required name=search_term_string"
  }
};

export const breadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": items.map((item, index) => ({
    "@type": "ListItem",
    "position": index + 1,
    "name": item.name,
    "item": item.url
  }))
});

export const destinationSchema = (destino) => ({
  "@context": "https://schema.org",
  "@type": "TouristDestination",
  "name": `${destino.ciudad}, ${destino.pais}`,
  "description": destino.descripcion,
  "image": `https://belutoursviajesyturismo.tur.ar${destino.imagen}`,
  "address": {
    "@type": "PostalAddress",
    "addressLocality": destino.ciudad,
    "addressCountry": destino.pais
  },
  "isPartOf": {
    "@type": "Country",
    "name": destino.pais
  }
});
